import React from 'react';
import { BsUpload } from 'react-icons/bs';

import { useAppDispatch } from 'store/hooks';
import { setModalInvoiceState } from 'store/modal_invoice/modal_invoice.slice';

import { UploadInvoiceButtonContainer } from './upload-invoice-button.styles';

export const UploadInvoiceButton = () => {
  const dispatch = useAppDispatch();

  const handleUploadInvoiceClicked = () => {
    dispatch(setModalInvoiceState({ modalState: 'select_invoice' }));
  };

  return (
    <UploadInvoiceButtonContainer onClick={handleUploadInvoiceClicked}>
      Importar conta de luz
      <BsUpload />
    </UploadInvoiceButtonContainer>
  );
};
